import React from "react";

const SpicyLevelSelector = ({
  currentSpicyLevel,
  onChange,
  onStopPropagation,
  shouldShowTable = true,
}) => {
  // Spicy level mapping
  const spicyLevel = {
    1: "Not Spicy",
    2: "Mild",
    3: "Medium",
    4: "Spicy",
    5: "Very Spicy",
    6: "Extra Spicy",
  };

  // Don't render if flag is false
  if (!shouldShowTable) {
    return null;
  }

  return (
    <div className="mt-2">
      <label className="small fw-semibold text-muted">Spicy Level</label>
      <select
        className="form-select form-select-sm mt-1"
        value={currentSpicyLevel || 0}
        onChange={onChange}
        onClick={(e) => onStopPropagation && onStopPropagation(e)}
      >
        <option value={0}>Select</option>
        {Object.entries(spicyLevel).map(([level, label]) => (
          <option key={level} value={level}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SpicyLevelSelector;